import { useEffect } from "react";
import { useNavigate, useLocation, useParams } from "react-router-dom";
import withTranslation, {
	Translation,
} from "src/components/hoc/withTranslation";
import Layout from "src/components/layout/Layout";
import RegistrationAcceptList from "src/components/lists/RegistrationAcceptList";
import RegistrationDetailModal from "src/components/modals/RegistrationDetailModal";
import SubtasksGrid from "src/components/tasks/SubtasksGrid";
import TaskCompanyHead from "src/components/tasks/TaskCompanyHead";
import useTask from "src/hooks/api/tasks/useTask";

function TasksDetailEventView({ t }: Translation) {
	const location = useLocation();
	const navigate = useNavigate();
	const { id, registration } = useParams() as any;
	const { task, actions, status } = useTask();

	useEffect(() => {
		if (!task?.id || task?.hid !== id) {
			actions.get(true, "variant=event");
		}
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [location]);

	return (
		<Layout
			backUrl="/tasks"
			loading={status === "loading"}
			{...actions.getHeadProps()}
		>
			<RegistrationDetailModal
				registrationId={registration}
				modal={{
					visible: registration ? registration : false,
					onClose: () => navigate(`/tasks/${id}/show`),
				}}
			/>

			<TaskCompanyHead {...{ task }} />

			{task?.id && (
				<>
					{task?.has_subtasks ? (
						<SubtasksGrid {...{ task }} />
					) : (
						<RegistrationAcceptList
							matches={{
								total: task.amount_of_students,
								count: task.matches?.count,
							}}
							taskHid={id}
							taskId={Number(task.id)}
						/>
					)}
				</>
			)}
		</Layout>
	);
}

TasksDetailEventView.locale = {
	nl: {
		registration: {
			title: "Aanmelding",
		},
		actions: {
			edit: "Aanpassen",
			hours: "Uren controle",
		},
	},
	en: {
		registration: {
			title: "Registration",
		},
		actions: {
			edit: "Edit",
			hours: "Hour validation",
		},
	},
};

export default withTranslation(TasksDetailEventView);
